export default [
    {
        path: '',
        name: 'pageLayanan',
        component: () => import('./page-layanan')
    }
]